/**
 * Filling in a tour step's `{name}` with a real record, at the moment the tour
 * runs (docs/LIVE-DATA.md: never hard-code a record).
 *
 * The spine can't know this project's records, so each placeholder is
 * registered by the project (src/tour-placeholders.ts). A placeholder answers
 * with an id, or null when there is no such record right now — the tour then
 * says it couldn't find the change, and offers Skip.
 */
import { TOUR_PLACEHOLDER } from '@/core/system'

type Resolve = () => Promise<string | null>

const placeholders = new Map<string, Resolve>()

export function registerTourPlaceholder(name: string, resolve: Resolve) {
  placeholders.set(name, resolve)
}

/** The address with every `{name}` filled in, or null if one can't be. */
export async function resolveTourRoute(route: string): Promise<string | null> {
  const names = [...new Set([...route.matchAll(TOUR_PLACEHOLDER)].map((match) => match[1] ?? ''))]
  let href = route
  for (const name of names) {
    const resolve = placeholders.get(name)
    const id = resolve ? await resolve().catch(() => null) : null
    if (!id) return null
    href = href.replaceAll(`{${name}}`, encodeURIComponent(id))
  }
  return href
}
